import {selectDomain} from '.';
import {createSelector} from 'reselect';

export const selectLatestCreatedFamily = createSelector(
  [selectDomain],
  productionState => {
    return productionState.latestCreatedFamily;
  }
);
